import { submissionOverview } from "@/models/equip-api-response-objects/submissionOverview";
import { Get } from "./utilities-api";

export function GetSubmissionOverview(companyId: string): Promise<submissionOverview> {
  return Get<submissionOverview>("/submission/company/current", {
    companyId: companyId
  });
}
